/* BI-06 · TAX & VAT PROFILE
   Tax wording is only called « vérifiée » with the accountant’s sign-off and
   production proof — launch gate ADM-42/47. */
import { Card, KV, Note, Pill } from '@/ui'
import { Head, useBill } from './ParamShell'

export default function BI06Profil() {
  const t = useBill().taxProfile
  return (
    <section data-frame="BI-06" style={{ display: 'grid', gap: 14 }}>
      <Head title="Profil de facturation" />
      <Card>
        <KV rows={[
          ['Entité facturée', t.entity],
          ['N° TVA', <>{t.vat} <Pill tone={t.vatStatus.tone} mark={t.vatStatus.mark}>{t.vatStatus.label}</Pill></>],
          ['Traitement', t.treatment],
          ['Vendeur', t.seller],
        ]} />
      </Card>
      <Note tone="candour">
        Les mentions fiscales ne sont dites « vérifiées » qu’avec l’accord comptable + preuve en
        production (porte de lancement ADM-42/47).
      </Note>
    </section>
  )
}
